"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDynatraceInstance = createDynatraceInstance;
exports.validateInitialization = validateInitialization;
exports.logTimeMetricStatus = logTimeMetricStatus;
exports.traceSQLDatabaseRequest = traceSQLDatabaseRequest;
exports.traceIncomingRemoteCall = traceIncomingRemoteCall;
exports.traceOutgoingRemoteCall = traceOutgoingRemoteCall;
exports.traceIncomingMessage = traceIncomingMessage;
exports.traceOutgoingMessage = traceOutgoingMessage;
exports.getTraceContextInfo = getTraceContextInfo;
exports.getCurrentState = getCurrentState;
const oneagent_sdk_1 = require("@dynatrace/oneagent-sdk");
const types_1 = require("./types");
/**
 * Utility function to create a Dynatrace SDK instance.
 */
function createDynatraceInstance() {
    return (0, oneagent_sdk_1.createInstance)();
}
/**
 * Utility function to validate the initialization of the reporter.
 */
function validateInitialization(config, initializer) {
    return initializer.showLogs !== undefined && config.token.length > 0;
}
/**
 * Utility function to log the status of a timed metric.
 */
function logTimeMetricStatus(logger, status, timedMetric, parentTimeMetric) {
    logger.info(`TimeMetric -- ${types_1.DynatraceTimeMetricStatus[status]}: ${timedMetric.eventName} - parent: ${parentTimeMetric === null || parentTimeMetric === void 0 ? void 0 : parentTimeMetric.eventName}`);
}
/**
 * Utility function to trace an SQL database request.
 */
function traceSQLDatabaseRequest(dynatraceSDK, databaseInfo, startData) {
    return dynatraceSDK.traceSQLDatabaseRequest(databaseInfo, startData);
}
/**
 * Utility function to trace an incoming remote call.
 */
function traceIncomingRemoteCall(dynatraceSDK, startData) {
    return dynatraceSDK.traceIncomingRemoteCall(startData);
}
/**
 * Utility function to trace an outgoing remote call.
 */
function traceOutgoingRemoteCall(dynatraceSDK, startData) {
    return dynatraceSDK.traceOutgoingRemoteCall(startData);
}
/**
 * Utility function to trace an incoming message.
 */
function traceIncomingMessage(dynatraceSDK, startData) {
    return dynatraceSDK.traceIncomingMessage(startData);
}
/**
 * Utility function to trace an outgoing message.
 */
function traceOutgoingMessage(dynatraceSDK, startData) {
    return dynatraceSDK.traceOutgoingMessage(startData);
}
/**
 * Utility function to get the trace context information.
 */
function getTraceContextInfo(dynatraceSDK) {
    return dynatraceSDK.getTraceContextInfo();
}
/**
 * Utility function to get the current state of the SDK.
 */
function getCurrentState(dynatraceSDK) {
    return dynatraceSDK.getCurrentState();
}
//# sourceMappingURL=dynatraceReporter.js.map